import { render } from "./PrivacyFooter.vue?vue&type=template&id=e4c1b2c4&scoped=true"
import script from "./PrivacyFooter.vue?vue&type=script&lang=js"
export * from "./PrivacyFooter.vue?vue&type=script&lang=js"

import "./PrivacyFooter.vue?vue&type=style&index=0&id=e4c1b2c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c1b2c4"]])

export default __exports__